import React, { useState } from 'react';
import {
  Button,
  Sprite,
  ToggleInput,
  ToggleInputGroup,
} from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';
import useGetFlatHierachie from './useGetFlatHierachie';

const getClassname = (path: string) => {
  const level = path.split('-').length - 2;
  return `adminview-hierarchy__item adminview-hierarchy__item--level-${level}`;
};

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

const AdminViewHierarchy = () => {
  const { t } = useTranslation('jobs');
  const [selectedPaths, setSelectedPaths] = useState<string[]>([]);
  const flatHierachies = useGetFlatHierachie();

  const onCopySelectedPathsToClipboard = () => {
    let items = '';
    selectedPaths.forEach((path) => {
      if (items) {
        items += ', ';
      }
      items += `${path.split('-').pop()}`;
    });
    navigator.clipboard.writeText(items);
  };

  const onSelectElement = (path: string, checked: boolean) => {
    let newPaths = [...selectedPaths];
    if (checked) {
      newPaths = newPaths.filter((p) => p !== path);
    } else {
      newPaths.push(path);
    }

    const children = flatHierachies.filter((item) => item.path.startsWith(`${path}-`));

    if (!children.length) {
      setSelectedPaths(newPaths);
      return;
    }

    const areAllChildrenChecked = children.every((child) =>
      newPaths.includes(child.path),
    );

    if (areAllChildrenChecked) {
      if (!newPaths.includes(path)) {
        newPaths = newPaths.filter((p) => !children.map((c) => c.path).includes(p));
      }
    } else {
      newPaths.push(...children.map((c) => c.path).filter((c) => !newPaths.includes(c)));

      if (!newPaths.includes(path)) {
        newPaths.push(path);
      }
    }

    setSelectedPaths(newPaths);
  };

  const onDeselectAll = () => {
    setSelectedPaths([]);
  };

  return (
    <div className="adminview-hierarchy">
      <Button
        primary
        onClick={onCopySelectedPathsToClipboard}
        disabled={!selectedPaths?.length}
      >
        {t('adminview_copy_selected_paths')}
      </Button>
      <Button
        onClick={onDeselectAll}
        disabled={!selectedPaths?.length}
        additionalClassNames="adminview-hierarchy__deselect-all"
      >
        {t('adminview_deselect_all')}
      </Button>
      <ToggleInputGroup name="hierarchies" type="checkbox">
        {flatHierachies.map((item) => (
          <ToggleInput
            additionalClassNames={getClassname(item.path)}
            key={item.path}
            id={item.path}
            value={item.path}
            label={
              <span className="adminview__cell-id">
                {`${item.name} (${item.path.split('-').pop()})`}
                <Sprite
                  id="copy"
                  onClick={() => copyToClipboard(item.path.split('-').pop())}
                  additionalClassNames="adminview__copy-icon"
                />
              </span>
            }
            checked={selectedPaths.includes(item.path)}
            onChange={() => onSelectElement(item.path, selectedPaths.includes(item.path))}
          />
        ))}
      </ToggleInputGroup>
    </div>
  );
};

export default AdminViewHierarchy;
